import health1 from '../assets/images/health/01.jpg'
import health2 from '../assets/images/health/04.jpg'
import health3 from '../assets/images/health/05.jpg'

import team1 from '../assets/images/team/09.jpg'
import team2 from '../assets/images/team/10.jpg'
import team3 from '../assets/images/team/11.jpg'
import team4 from '../assets/images/team/12.jpg'
import team5 from '../assets/images/team/13.jpg'
import team6 from '../assets/images/team/14.jpg'
import team7 from '../assets/images/team/15.jpg'
import team8 from '../assets/images/team/16.jpg'

import {LuCalendarDays, TbHours24, FaRegHospital, TbHeartbeat, TbAmbulance,GiMedicalDrip, CgThermometer, RiCapsuleLine, LiaBrainSolid} from '../assets/icons/vander'
export const tabLink = [
    {
        id:1,
        icon:LuCalendarDays,
        name:'Mack an appointment',
        title:'Available'
    },
    {
        id:2,
        icon:TbHours24,
        name:'Emergency service',
        title:'Available'
    },
    {
        id:3,
        icon:FaRegHospital,
        name:'Health Care',
        title:'Available'
    },
]

export const tabImg = [
    {
        id:1,
        image:health1
    },
    {
        id:2,
        image:health2
    },
    {
        id:3,
        image:health3
    },
]

export const healthCounter = [
    {
       title:'Best Doctor',
       value:'250' 
    },
    {
        title:'Clinic Location',
        value:'50' 
     },
     {
        title:'Surgery Room',
        value:'100' 
     },
     {
        title:'Patient Capacity',
        value:'1500' 
     },
]

export const healthFeature = [
    {
        icon:TbHeartbeat,
        title:'Cardio Surgery',
        desc:"The most well-known dummy text is the 'Lorem', which well-known is said which is said to have in."
    },
    {
        icon:TbAmbulance,
        title:'Emergency Clinic',
        desc:"One disadvantage of Lorum Ipsum is that in certain letters which is said appear more than."
    },
    {
        icon:GiMedicalDrip,
        title:'Syringe',
        desc:"Moreover, in Latin only words at the beginning of sentences which is said are capitalized."
    },
    {
        icon:CgThermometer,
        title:'Temperature',
        desc:"If the fill text is intended to illustrate the characteristics well-known which is said of sometimes."
    },
    {
        icon:RiCapsuleLine,
        title:'Primary Care',
        desc:"There is now an abundance of readable dummy texts. These are which well-known is said text is."
    },
    {
        icon:LiaBrainSolid,
        title:'Brain Surgery',
        desc:"These alternatives to the classic are often amusing and tell short, which is said stories."
    },
]

export const teamData = [
    {
        image:team1,
        name:'Calvin Carlo',
        position:'Founder',
        social:["mdi mdi-facebook","mdi mdi-instagram","mdi mdi-twitter","mdi mdi-google-plus","mdi mdi-linkedin"]
    },
    {
        image:team2,
        name:'Martin Sobhe',
        position:'C.E.O.',
        social:["mdi mdi-facebook","mdi mdi-instagram","mdi mdi-twitter","mdi mdi-google-plus","mdi mdi-linkedin"]
    },
    {
        image:team3,
        name:'Bobby DE',
        position:'Coach',
        social:["mdi mdi-facebook","mdi mdi-instagram","mdi mdi-twitter","mdi mdi-google-plus","mdi mdi-linkedin"]
    },
    {
        image:team4,
        name:'Cristino Murphy',
        position:'Manager',
        social:["mdi mdi-facebook","mdi mdi-instagram","mdi mdi-twitter","mdi mdi-google-plus","mdi mdi-linkedin"]
    },
    {
        image:team5,
        name:'Calvin Carlo',
        position:'Founder',
        social:["mdi mdi-facebook","mdi mdi-instagram","mdi mdi-twitter","mdi mdi-google-plus","mdi mdi-linkedin"]
    },
    {
        image:team6,
        name:'Martin Sobhe',
        position:'C.E.O.',
        social:["mdi mdi-facebook","mdi mdi-instagram","mdi mdi-twitter","mdi mdi-google-plus","mdi mdi-linkedin"]
    },
    {
        image:team7,
        name:'Bobby DE',
        position:'Coach',
        social:["mdi mdi-facebook","mdi mdi-instagram","mdi mdi-twitter","mdi mdi-google-plus","mdi mdi-linkedin"]
    },
    {
        image:team8,
        name:'Cristino Murphy',
        position:'Manager',
        social:["mdi mdi-facebook","mdi mdi-instagram","mdi mdi-twitter","mdi mdi-google-plus","mdi mdi-linkedin"]
    },
]